import BaseComponent from '../BaseComponent';
import { Events } from '../../utils/dom/html-events';
import SelectorEngine from '../../utils/dom/selector-engine';

const NAME = 'CoachAreaResourceCard';
const BOOKMARK_BUTTON_SELECTOR = '.js-lta-coach-area-resource-card--bookmark ';

class CoachAreaResourceCard extends BaseComponent {
	constructor(element) {
		super(element);
		this.init();
	}

	static get NAME() {
		return NAME;
	}

	init() {
		this.bookmarkButton = SelectorEngine.findOne(BOOKMARK_BUTTON_SELECTOR, this._element);
		this.bookmarkButton.addEventListener(Events.Click, () => this.handleBookmarkAdd());
	}

	handleBookmarkAdd() {
		// TODO CSA: add API call once we have the contract
	}
}

export default CoachAreaResourceCard;
